import * as React from 'react'
import { useFormContext } from 'react-hook-form'

export default function Smart({ children }) {
    const { register } = useFormContext()

    return React.Children.toArray(children).map(child => {
        const { name } = child.props

        if (!name) {
            return child
        }

        return React.cloneElement(child, {
            key: name,
            register,
        })
    })
}
